import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { LoginViaThirdPartiesService } from './login-via-third-parties.service';

@NgModule({
  imports: [HttpClientModule],
})
export class LoginViaThirdPartiesModule {
  static forRoot() {
    return {
      ngModule: LoginViaThirdPartiesModule,
      providers: [LoginViaThirdPartiesService]
    };
  }
}
